// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inlineActivityEditor_8Lnqz77t{margin:0px auto;flex:1}.inlineActivityEditor_8Lnqz77t .tab-pane .card{margin-bottom:10px}.inlineActivityEditor_8Lnqz77t .slate-editor{padding:.5rem;border:1px solid var(--color-gray-300);border-radius:.25em}.inlineActivityEditor_8Lnqz77t .slate-editor.disabled_XJ3dI1yx{background:var(--color-gray-100)}.inlineActivityEditor_8Lnqz77t .toolbar_v\\+-dntDg{display:flex;flex-direction:row;margin:8px 0}html.dark .rich-text-editor > .slate-editor{border-color:var(--color-gray-600);outline:none}html.dark .rich-text-editor > .slate-editor.disabled_XJ3dI1yx{background:var(--color-gray-800)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inlineActivityEditor": "inlineActivityEditor_8Lnqz77t",
	"disabled": "disabled_XJ3dI1yx",
	"toolbar": "toolbar_v+-dntDg"
};
export default ___CSS_LOADER_EXPORT___;
